export type TFilterFieldType = 'boolean' | 'number' | 'string';

export type TFilterSchema<T> = Partial<Record<keyof T, TFilterFieldType>>;

const coerce = (value: string, type: TFilterFieldType) => {
  if (type === 'boolean') return value === 'true';

  if (type === 'number') return Number(value);

  return value;
};

export const parseFiltersFromQs = <T extends object>(
  searchParams: URLSearchParams,
  schema: TFilterSchema<T>,
): T | undefined => {
  const result: Record<string, unknown> = {};

  Object.entries(schema).forEach(([key, type]) => {
    const raw = searchParams.get(`filter[${key}]`);

    if (raw !== null) result[key] = coerce(raw, type as TFilterFieldType);
  });

  return Object.keys(result).length ? (result as T) : undefined;
};
